// 不同环境下，不同路由的分享图配置
export const shareImageConfig = {
  'h5': {},
  'wx': {
    default: 'https://static.wecity.qq.com/wuhan-static/wuhan-h5-share-pic.png',
    mapLanding: 'https://static.wecity.qq.com/wuhan-static/wuhan-h5-share-pic.png',
    FeiYanMap: 'https://static.wecity.qq.com/wuhan-static/wuhan-h5-share-pic.png',
    selftest: 'https://static.wecity.qq.com/wuhan-static/selftest-share-h5-14d4a3c2e1375cce84b6ef0de1b1b624.jpg',
    aiqna: 'https://static.wecity.qq.com/h5/2020-2/aiqa-h5-share-914335c4f3046304cb4a9d0259069f8c.jpg',
    travel: 'https://static.wecity.qq.com/h5/2020-8/%E5%88%86%E4%BA%AB%E5%9B%BE(1)-6cc5c4dbf6ea1b2f03b04cfc25cf44fc.png',
  },
  'mini': {
    default: 'https://static.wecity.qq.com/auto-create-image-sotre/wuhan-share-with-number-formal.png?x_cache_fresh=on',
    mapLanding: 'https://static.wecity.qq.com/tencent-health-mini/share-map-0397a469af838291a2d02ea433fd7c99.jpg',
    FeiYanMap: 'https://static.wecity.qq.com/tencent-health-mini/share-map-0397a469af838291a2d02ea433fd7c99.jpg',
    selftest: 'https://static.wecity.qq.com/wuhan-static/selftest-share-wx-d9abf59fc3191a4e9573288c52023153.jpg',
    aiqna: 'https://static.wecity.qq.com/h5/2020-2/aiqa-mini-share-988d1f457b4a80f1ea6daa76532b0432.jpg',
    travel: 'https://static.wecity.qq.com/h5/2020-8/%E5%88%86%E4%BA%AB%E5%9B%BE(1)-6cc5c4dbf6ea1b2f03b04cfc25cf44fc.png',
  }
}

// 锚点滚动位置
export const SCROLL_POS = {
  FOREIGN_DETAIL: 'FOREIGN_DETAIL',
}
